import { render, staticRenderFns } from "./CalendarAdminPlusScheduleClassDialog.vue?vue&type=template&id=5619203c&scoped=true"
import script from "./CalendarAdminPlusScheduleClassDialog.vue?vue&type=script&lang=js"
export * from "./CalendarAdminPlusScheduleClassDialog.vue?vue&type=script&lang=js"
import style0 from "./CalendarAdminPlusScheduleClassDialog.vue?vue&type=style&index=0&id=5619203c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5619203c",
  null
  
)

export default component.exports